import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '../store/reducers';
import rootSaga from '../store/sagas';
import { routerMiddleware } from '../history';

function configureStore() {
    // Redux saga config
    const sagaMiddleware = createSagaMiddleware();

    // const enhancers =
    //     !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
    //         ? composeWithDevTools(
    //               applyMiddleware(sagaMiddleware, routerMiddleware(history))
    //           )
    //         : compose(applyMiddleware(sagaMiddleware, routerMiddleware(history)));

    const store = createStore(
        reducers,
        {},
        applyMiddleware(sagaMiddleware, routerMiddleware)
    );

    sagaMiddleware.run(rootSaga);

    return store;
}

const store = configureStore();

export default store;
